import { createApi } from '@reduxjs/toolkit/query/react';
import { authApi } from '@/api/authApi/authApi';
import { LoginDataIF } from '@/api/authApi/types';
import {
    ChangeUserDataIF,
    ChangeUserPasswordIF,
    UserIF,
    NumberOfAvailableOutfitsT,
    TokenModelIF,
    CreateUserWithConfirmRequestIF,
} from '@/api/userApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: fetchRestApiQuery('/Users'),
    tagTypes: ['GetNumOfAvailableOutfits'],
    endpoints: (builder) => ({
        createUserWithConfirm: builder.mutation<
            LoginDataIF,
            CreateUserWithConfirmRequestIF
        >({
            query: (body) => ({
                url: '/',
                method: 'POST',
                body,
            }),
        }),
        changeUserData: builder.mutation<UserIF, ChangeUserDataIF>({
            query: (body) => ({
                url: '/',
                method: 'PUT',
                body,
            }),
            onQueryStarted: async (
                updatedData,
                { queryFulfilled, dispatch },
            ) => {
                const patchResult = dispatch(
                    authApi.util.updateQueryData(
                        'getCurrentUser',
                        undefined,
                        (draft) => {
                            Object.assign(draft, updatedData);
                        },
                    ),
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
        passwordRecovery: builder.mutation<TokenModelIF, ChangeUserPasswordIF>({
            query: (body) => ({
                url: '/Recovery',
                method: 'PUT',
                body,
            }),
        }),
        getNumOfAvailableOutfits: builder.query<
            NumberOfAvailableOutfitsT,
            void
        >({
            query: () => ({
                url: '/NumOfAvailableOutfits',
            }),
            transformResponse(response: { availableCreations: number }) {
                if (response.availableCreations < 0) {
                    return { type: 'unlimited' };
                }

                return {
                    type: 'limited',
                    count: response.availableCreations,
                };
            },
        }),
        getNumOfAvailableEvents: builder.query<number, void>({
            query: () => ({
                url: '/NumOfAvailableEvents',
            }),
            transformResponse(response: { availableCreations: number }) {
                return response.availableCreations || 0;
            },
        }),
    }),
});
